<template lang="pug">
    v-card.card-area
        v-container.content
            v-layout(row wrap)
                v-flex.xs4.tile
                    span.font-weight-bold Código Interno:
                v-flex.xs8.tile
                    span {{item.alias_name}}
                v-flex.xs4.tile
                    span.font-weight-bold Nombre:
                v-flex.xs8.tile
                    span {{item.name}}
                v-flex.xs4.tile
                    span.font-weight-bold Stock:
                v-flex.xs8.tile
                    span {{item.total_branch_office_stock || 'AGOTADO'}}
                v-flex.xs4.tile
                    span.font-weight-bold Cantidad:
                v-flex.xs8.tile.input
                    input(
                        v-model="item.quantity"
                        @blur="handleQuantity"
                        @keydown="handleKeydown"
                        type="number"
                        )
                template(v-if="discount")
                    v-flex.xs4.tile
                        span.font-weight-bold Descuento:
                    v-flex.xs8.tile
                        span {{discount}}
                v-flex.xs4.tile
                    span.font-weight-bold Precio Final:
                v-flex.xs8.tile
                    span {{salePrice | mixFormatCurrency}}
                        span.ml-3.font-weight-bold(v-if="isReplaced") (R)
                v-flex.xs12
                    span.font-weight-bold Descripción:
                    br
                    p {{item.description}}
                v-flex.xs12
                    v-btn(
                        large
                        block
                        dark
                        :color="colors.secondary"
                        @touchend="$router.push('/mobile')"
                        )
                        v-icon arrow_left
                        span VOLVER
</template>
<script>
import CurrencyUtils from '@/mixins/CurrencyUtils'
import { mapGetters, mapState, mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            activeInput: null,
            showDialog: false,
        }
    },
    computed: {
        ...mapGetters('CartModule', {
            activeMobileItem: 'activeMobileItem',
        }),
        ...mapState('CartModule', {
            cartItems: 'items',
        }),
        item() {
            return this.activeMobileItem
        },
        salePrice() {
            if (this.item.neto) return this.item.altPrice
            if (this.item.discounted_price) return this.item.discounted_price
            return this.item.sale_price
        },
        originalPrice() {
            if (this.item.replaced_price)
                return this.item.replaced_price.original
            return this.item.sale_price
        },
        discount() {
            console.log("this.item",this.item)
            if (this.item.discounted_price) return this.item.active_discount.unit_price_discount
            if (!this.item.lineDiscount) return false
            let {
                percentage_discount,
                unit_price_discount,
            } = this.item.lineDiscount
            if (percentage_discount) return `${percentage_discount}%`
            if (unit_price_discount) return `$${unit_price_discount}`
            return false
        },
        isReplaced() {
            return this.item.replaced_price && this.item.replaced_price.replaced
        },
        activeWarehouse() {
            if (!this.item.stocks || !this.item.active_warehouse) return false
            return this.item.stocks
                .map(s => s.wh_warehouses)
                .flat()
                .find(w => w.wh_warehouse_id === this.item.active_warehouse)
                .wh_warehouse_name
        },
        quantity() {
            return this.item.quantity
        },
    },
    methods: {
        replacePrice(e) {
            if (this.item.replaced_price) {
                if (this.item.replaced_price.original == e) {
                    delete this.item.replaced_price
                }
            } else {
                this.item.replaced_price = {}
                this.item.replaced_price.original = this.item.sale_price
                this.item.replaced_price.replaced = true
            }
            this.item.sale_price = e
            this.item.sale_prices = this.item.sale_prices.map(prc => {
                prc.sale_price = e
                return prc
            })
            this.$emit('item:update', this.item)
        },
        handleQuantity() {
            if (!this.item.quantity) this.item.quantity = 1
            if (this.item.quantity > this.item.total_branch_office_stock)
                this.item.quantity = this.item.total_branch_office_stock
            this.setCartItems(cloneDeep(this.cartItems))
        },
        ...mapActions('CartModule', ['setCartItems']),
        handleKeydown(e) {
            const stopPrevent = event => {
                event.preventDefault()
                event.stopPropagation()
            }
            if (e.key.length === 1 && isNaN(e.key) && e.key !== '.')
                stopPrevent(e)
        },
    },
    watch: {
        quantity(v) {
            if (v > this.item.total_branch_office_stock)
                this.item.quantity = this.item.total_branch_office_stock
        },
    },
    mixins: [CurrencyUtils],
}
</script>

<style lang="scss" scoped>
.card-area {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.tile {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 48px;
    &.input {
        margin-top: -10px;
        margin-bottom: -10px;
        input {
            border-bottom: 1px solid black;
            box-shadow: none;
            padding-left: 10px;
        }
    }
    .btn {
        min-width: 120px;
    }
}
</style>
